import React, { useState, useEffect } from 'react'
import {
  Button,
  Card,
  Col,
  DatePicker,
  Form,
  Input,
  Row,
  Select,
  Table
} from 'antd'
import { useDispatch, useSelector } from 'react-redux'
import { useDeepEffect } from '../../utils/hooks'
import { fetchAllBillReport, fetchAllReport } from '../../modules/reports'
import moment from 'moment'
import axios from 'axios'
import { groupBy, isEmpty, isNull, isUndefined, some } from 'lodash'
import { DATE, ENDPOINT } from '../../utils/constants'
import { ButtonEx } from '../../styles/button.style'
import WrappedBillForm from './components/BillForm'
import WrappedUserForm from './components/UserForm'
import '../../../node_modules/react-image-lightbox/style.css'
import styled from 'styled-components'
import Modal from 'antd/lib/modal'

const { RangePicker } = DatePicker

const Transaction = ({ form, data }) => {
  const dispatch = useDispatch()
  const { validateFields, getFieldDecorator } = form
  const [filterOptions, setFilterOptions] = useState({
    size: 20,
    page: 0
  })
  const [statusOption, setStatusOption] = useState(true)
  const [status, setStatus] = useState([])
  const [userNameOption, setUserNameOption] = useState(true)
  const [userName, setUserName] = useState([])
  const [heroNameOption, setHeroNameOption] = useState(true)
  const [heroName, setHeroName] = useState([])
  const [activityOption, setActivityOption] = useState(true)
  const [activity, setActivity] = useState([])
  const [date, setDate] = useState([moment(new Date()), moment(new Date())])
  const [visible, setVisible] = useState(false)
  const [formData, setFormData] = useState({})
  const [formDataBill, setFormDataBill] = useState({})
  const [visibleUser, setVisibleUser] = useState(false)
  const [formDataUser, setFormDataUser] = useState({})
  const [imageList, setImageList] = useState([])
  const MAX_IMAGES = 5

  const { transactionList, allList, isLoading } = useSelector(
    (state) => ({
      allList: state.reports.allList,
      transactionList: state.reports.allTransactionList,
      isLoading: state.reports.isLoading
    }),
    []
  )

  const ImageGallery = ({ images = [] }) => {
    const [validImages, setValidImages] = useState([])
    const [isPreviewOpen, setIsPreviewOpen] = useState(false)
    const [currentImageIndex, setCurrentImageIndex] = useState(0)

    useEffect(() => {
      const loadedImages = []
      let loadedCount = 0

      images.forEach((src, index) => {
        const img = new Image()
        img.onload = () => {
          loadedImages.push(src)
          loadedCount++
          if (loadedCount === images.length) {
            setValidImages(loadedImages)
          }
        }
        img.onerror = () => {
          loadedCount++
          if (loadedCount === images.length) {
            setValidImages(loadedImages)
          }
        }
        img.src = src
      })
    }, [images])

    if (!validImages.length) {
      return <p>ไม่มีรูปภาพ</p>
    }

    const openPreview = (index) => {
      setCurrentImageIndex(index)
      setIsPreviewOpen(true)
    }

    return (
      <div>
        <GalleryContainer>
          {validImages.slice(0, MAX_IMAGES).map((image, index) => (
            <ImageBox key={index} onClick={() => openPreview(index)}>
              <img src={image} alt={`cover-${index}`} />
            </ImageBox>
          ))}
          {validImages.length > MAX_IMAGES && (
            <MoreButton onClick={() => openPreview(0)}>ดูรูปภาพ</MoreButton>
          )}
        </GalleryContainer>
        <Modal
          visible={isPreviewOpen}
          footer={null}
          onCancel={() => setIsPreviewOpen(false)}
          centered
          closable={false}
          width={800}>
          <PreviewImageContainer>
            <img
              src={validImages[currentImageIndex]}
              alt={`preview-${currentImageIndex}`}
            />
          </PreviewImageContainer>
          <ThumbnailContainer>
            {validImages.map((image, index) => (
              <ThumbnailBox
                key={index}
                onClick={() => setCurrentImageIndex(index)}>
                <img src={image} alt={`thumb-${index}`} />
              </ThumbnailBox>
            ))}
          </ThumbnailContainer>
        </Modal>
      </div>
    )
  }

  async function fetchData() {
    await dispatch(fetchAllReport())
    await dispatch(fetchAllBillReport(filterOptions))
  }

  useDeepEffect(() => {
    form.setFieldsValue({
      status: [0],
      userName: [0],
      heroName: [0],
      activityName: [0]
    })
    fetchData()
  }, [])

  useDeepEffect(() => {
    if (!isEmpty(transactionList)) {
      setStatusSelect()
      setUserNameSelect()
      setHeroNameSelect()
      setSelectActivity()
      setImageBill()
    }
  }, [transactionList])

  useDeepEffect(() => {
    console.log('📌 Updated imageList:', imageList)
  }, [imageList])

  async function setStatusSelect() {
    const arr = groupBy(allList, 'status')
    const results = []
    for (const item of Object.keys(arr)) {
      if (item !== 'null') {
        results.push({
          status: item
        })
      }
    }
    setStatus(results)
  }
  async function setUserNameSelect() {
    const arr = groupBy(allList, 'userName')
    const results = []
    for (const item of Object.keys(arr)) {
      if (item !== 'null') {
        results.push({
          userName: item
        })
      }
    }
    setUserName(results)
  }
  async function setHeroNameSelect() {
    const arr = groupBy(allList, 'heroName')
    const results = []
    for (const item of Object.keys(arr)) {
      if (item !== 'null') {
        results.push({
          heroName: item
        })
      }
    }
    setHeroName(results)
  }

  async function setImageBill() {
    const groupedByReference = groupBy(transactionList.content, 'referenceCode')

    const results = Object.entries(groupedByReference).map(
      ([referenceCode, transactions]) => ({
        referenceCode,
        images: transactions.flatMap((t) =>
          Array.isArray(t.imageBillItemList) ? t.imageBillItemList : []
        )
      })
    )

    console.log('📌 Processed image list grouped by referenceCode:', results)

    setImageList(results)
  }

  async function setSelectActivity() {
    const arr = groupBy(allList, 'brandActivity')
    const results = []
    for (const item of Object.keys(arr)) {
      if (item !== 'null') {
        results.push({
          activity: item
        })
      }
    }
    setActivity(results)
  }

  async function onShowSizeChange(current, pageSize) {
    filterOptions.size = pageSize
    filterOptions.page = 0
    setFilterOptions(filterOptions)
    await dispatch(fetchAllBillReport(filterOptions))
  }

  async function onChange(page) {
    filterOptions.page = page - 1
    setFilterOptions(filterOptions)
    await dispatch(fetchAllBillReport(filterOptions))
  }

  function onDateChange(date) {
    if (!isNull(date)) {
      setDate(date)
    } else {
      setDate([moment(new Date()), moment(new Date())])
    }
  }
  const onClick = (e, record) => {
    axios
      .get(
        process.env.REACT_APP_API_ENDPOINT + `/recycle/bill/` + record.billId
      )
      .then((res) => {
        setFormDataBill(res.data)
      })
    e.preventDefault()
    setFormData(record)
    setVisible(true)
  }

  const onCloseModal = () => {
    setVisible(false)
    fetchData()
  }

  const onClickUser = (e, record) => {
    if (record.userId != 0) {
      axios
        .get(process.env.REACT_APP_API_ENDPOINT + `/login/` + record.userId)
        .then((res) => {
          setFormDataUser(res.data.data)
        })
      console.log(formDataUser)
      e.preventDefault()
      setVisibleUser(true)
    }
  }

  const onCloseModalUser = async () => {
    await setVisibleUser(false)
  }

  const GetDate = (time) => {
    let date = ''
    if (time !== null) {
      date = moment(time).format('DD/MM/YYYY')
    }
    return date
  }

  function handleStatusChange(value) {
    const isAll = some(value, (item) => {
      return item === 'all'
    })
    if (isAll) {
      setStatusOption(true)
    } else {
      setStatusOption(false)
    }
  }

  function handleUserNameChange(value) {
    const isAll = some(value, (item) => {
      return item === 'all'
    })
    if (isAll) {
      setUserNameOption(true)
    } else {
      setUserNameOption(false)
    }
  }

  function handleHeroNameChange(value) {
    const isAll = some(value, (item) => {
      return item === 'all'
    })
    if (isAll) {
      setHeroNameOption(true)
    } else {
      setHeroNameOption(false)
    }
  }

  function handleActivityChange(value) {
    const isAll = some(value, (item) => {
      return item === 'all'
    })
    if (isAll) {
      setActivityOption(true)
    } else {
      setActivityOption(false)
    }
  }
  const columns = [
    {
      title: 'ลำดับ',
      render: (text, record, index) => (
        <span>{filterOptions.page * filterOptions.size + index + 1}</span>
      )
    },
    {
      title: 'เลขอ้างอิง',
      dataIndex: 'referenceCode',
      align: 'center',
      render: (text) => <span>{text || '-'}</span>
    },
    {
      title: 'วันที่ทำการส่งต่อ',
      dataIndex: 'date',
      align: 'center',
      render: (date) => {
        const start = GetDate(date)
        return <span>{start}</span>
      }
    },
    {
      title: 'จำนวนรายการที่ส่งต่อ',
      dataIndex: 'itemCount',
      align: 'center',
      width: 80,
      render: (text) => <span>{text || '-'}</span>
    },
    {
      title: 'สถานะ',
      dataIndex: 'status',
      align: 'center',
      render: (text) => <span>{text || '-'}</span>
    },
    {
      title: 'กิจกรรม',
      dataIndex: 'brandActivity',
      align: 'center',
      render: (text) => <span>{text || '-'}</span>
    },
    {
      title: 'ผู้ส่งต่อ',
      dataIndex: 'userName',
      align: 'center',
      render: (text, record) => (
        <span>
          {' '}
          {text ? (
            <div>
              <a
                onClick={(e) => {
                  onClickUser(e, record)
                }}>
                {text}
              </a>
            </div>
          ) : (
            '-'
          )}
        </span>
      )
    },
    {
      title: 'ผู้รับ',
      dataIndex: 'heroName',
      align: 'center',
      render: (text) => <span>{text || '-'}</span>
    },
    {
      title: 'รูปภาพหลักฐาน',
      dataIndex: 'imageBillItemList',
      align: 'center',
      render: (text, record) => {
        const images =
          imageList.length > 0
            ? imageList
                .filter((t) => t.referenceCode === record.referenceCode)
                .flatMap((t) => t.images)
            : []

        return (
          <div
            style={{
              padding: '10px',
              minHeight: 60,
              display: 'flex',
              alignItems: 'center'
            }}>
            {images.length > 0 ? (
              <ImageGallery images={images} />
            ) : (
              <span
                style={{
                  minHeight: 40,
                  display: 'flex',
                  alignItems: 'center'
                }}>
                กำลังโหลดข้อมูล...
              </span>
            )}
          </div>
        )
      }
    },
    {
      title: 'Action',
      key: 'action',
      fixed: 'right',
      width: 80,
      render: (text, record) => (
        <span>
          <Button
            type="primary"
            size="small"
            shape="circle"
            icon="eye"
            onClick={(e) => {
              onClick(e, record)
            }}
          />
        </span>
      )
    }
  ]

  const onClear = async (e) => {
    e.preventDefault()
    setFilterOptions((prevState) => {
      prevState.size = 20
      prevState.page = 0
      prevState.referenceCode = undefined
      prevState.status = undefined
      prevState.userName = undefined
      prevState.heroName = undefined
      prevState.activityName = undefined
      return prevState
    })

    form.setFieldsValue({
      referenceCode: '',
      status: [0],
      userName: [0],
      heroName: [0],
      activityName: [0]
    })

    await setStatusSelect()
    await setUserNameSelect()
    await setHeroNameSelect()
    await setSelectActivity()
    await dispatch(fetchAllBillReport(filterOptions))
  }

  const handleSubmit = (e) => {
    e.preventDefault()
    validateFields(async (err, values) => {
      if (!err) {
        filterOptions.referenceCode = values.referenceCode || undefined

        if (values.status) {
          if (values.status[0] === 0) {
            filterOptions.status = undefined
          } else {
            filterOptions.status = !isUndefined(values.status)
              ? values.status.join()
              : undefined
          }
        }
        if (values.userName) {
          if (values.userName[0] === 0) {
            filterOptions.userName = undefined
          } else {
            filterOptions.userName = !isUndefined(values.userName)
              ? values.userName.join()
              : undefined
          }
        }
        if (values.heroName) {
          if (values.heroName[0] === 0) {
            filterOptions.heroName = undefined
          } else {
            filterOptions.heroName = !isUndefined(values.heroName)
              ? values.heroName.join()
              : undefined
          }
        }
        if (values.activityName) {
          if (values.activityName[0] === 0) {
            filterOptions.activityName = undefined
          } else {
            filterOptions.activityName = !isUndefined(values.activityName)
              ? values.activityName.join()
              : undefined
          }
        }
        filterOptions.page = 0
        setFilterOptions(filterOptions)
        await dispatch(fetchAllBillReport(filterOptions))
      }
    })
  }
  return (
    <Row type="flex" gutter={[8, 8]}>
      <Col span={24}>
        <Row style={{ marginBottom: 15 }}>
          <Col xs={24} sm={24} md={24} lg={24} xl={24}>
            <Row type="flex" justify="end" gutter={8}>
              <Col>
                <RangePicker
                  value={date}
                  onChange={onDateChange}
                  format={DATE.FORMAT}
                />
              </Col>
              <Col>
                <ButtonEx color="#6ebf4b" type="primary">
                  <a
                    href={
                      ENDPOINT +
                      `/bin/export-admin-all?&from=${moment(date[0]).format(
                        DATE.FORMAT
                      )}&to=${moment(date[1]).format(DATE.FORMAT)}`
                    }
                    download>
                    Export Data
                  </a>
                </ButtonEx>
              </Col>
            </Row>
          </Col>
        </Row>
      </Col>
      <Col span={24}>
        <Card>
          <Form
            form={form}
            layout="vertical"
            colon={false}
            onSubmit={handleSubmit}>
            <Row gutter={8}>
              <Col span={24}>
                <Row gutter={8}>
                  <Col xs={18} sm={18} md={6} lg={6} xl={6}>
                    <Form.Item label="เลขอ้างอิง">
                      {getFieldDecorator('referenceCode')(
                        <Input placeholder="เลขอ้างอิง" />
                      )}
                    </Form.Item>
                  </Col>
                  <Col xs={18} sm={18} md={6} lg={6} xl={6}>
                    <Form.Item label="สถานะ">
                      {getFieldDecorator('status')(
                        <Select
                          allowClear={true}
                          mode="multiple"
                          showSearch={true}
                          onChange={handleStatusChange}
                          showArrow={true}
                          filterOption={false}
                          notFoundContent={null}>
                          <Select.Option value={0}>ทั้งหมด</Select.Option>
                          {status.map((status, index) => {
                            return (
                              <Select.Option
                                key={index}
                                value={status.status}
                                disabled={statusOption}>
                                {status.status}
                              </Select.Option>
                            )
                          })}
                        </Select>
                      )}
                    </Form.Item>
                  </Col>
                  <Col xs={18} sm={18} md={6} lg={6} xl={6}>
                    <Form.Item label="กิจกรรม">
                      {getFieldDecorator('activityName')(
                        <Select
                          allowClear={true}
                          mode="multiple"
                          showSearch={true}
                          onChange={handleActivityChange}
                          showArrow={true}
                          filterOption={false}
                          notFoundContent={null}>
                          <Select.Option value={0}>ทั้งหมด</Select.Option>
                          {activity.map((activity, index) => {
                            return (
                              <Select.Option
                                key={index}
                                value={activity.activity}
                                disabled={activityOption}>
                                {activity.activity}
                              </Select.Option>
                            )
                          })}
                        </Select>
                      )}
                    </Form.Item>
                  </Col>
                  <Col xs={18} sm={18} md={6} lg={6} xl={6}>
                    <Form.Item label="ผู้ส่งต่อ">
                      {getFieldDecorator('userName')(
                        <Select
                          allowClear={true}
                          mode="multiple"
                          showSearch={true}
                          onChange={handleUserNameChange}
                          showArrow={true}
                          notFoundContent={null}>
                          <Select.Option value={0}>ทั้งหมด</Select.Option>
                          {userName.map((userName, index) => {
                            return (
                              <Select.Option
                                key={index}
                                value={userName.userName}
                                disabled={userNameOption}>
                                {userName.userName}
                              </Select.Option>
                            )
                          })}
                        </Select>
                      )}
                    </Form.Item>
                  </Col>
                  <Col xs={18} sm={18} md={6} lg={6} xl={6}>
                    <Form.Item label="ผู้รับ">
                      {getFieldDecorator('heroName')(
                        <Select
                          allowClear={true}
                          mode="multiple"
                          showSearch={true}
                          onChange={handleHeroNameChange}
                          showArrow={true}
                          filterOption={false}
                          notFoundContent={null}>
                          <Select.Option value={0}>ทั้งหมด</Select.Option>
                          {heroName.map((heroName, index) => {
                            return (
                              <Select.Option
                                key={index}
                                value={heroName.heroName}
                                disabled={heroNameOption}>
                                {heroName.heroName}
                              </Select.Option>
                            )
                          })}
                        </Select>
                      )}
                    </Form.Item>
                  </Col>
                  <Col xs={18} sm={18} md={6} lg={6} xl={6}>
                    <Form.Item label="" style={{ marginTop: '1.75rem' }}>
                      <Row gutter={8} type="flex" justify="start">
                        <Col>
                          <Button type="primary" htmlType="submit">
                            ค้นหา
                          </Button>
                        </Col>
                        <Col>
                          <Button type="danger" onClick={(e) => onClear(e)}>
                            เคลียร์
                          </Button>
                        </Col>
                      </Row>
                    </Form.Item>
                  </Col>
                </Row>
              </Col>
            </Row>
          </Form>
        </Card>
      </Col>
      <Col span={24}>
        <Table
          rowKey={(record) => {
            return record.id
          }}
          bordered
          dataSource={transactionList.content}
          columns={columns}
          loading={isLoading}
          pagination={{
            current: !isEmpty(transactionList)
              ? transactionList.pageable.pageNumber + 1
              : 1,
            pageSize: transactionList.size,
            pageSizeOptions: ['10', '20', '50', '100'],
            showSizeChanger: true,
            onShowSizeChange: onShowSizeChange,
            onChange: onChange,
            total: transactionList.totalElements
          }}
          scroll={{ x: 'max-content' }}
        />
        <WrappedBillForm
          visible={visible}
          onCancel={onCloseModal}
          formData={formData}
          formDataBill={formDataBill}
        />
        <WrappedUserForm
          visible={visibleUser}
          onCancel={onCloseModalUser}
          formData={formDataUser}
        />
      </Col>
    </Row>
  )
}

const WrappedTransaction = Form.create({
  name: 'WrappedTransaction'
})(Transaction)

export default WrappedTransaction

const GalleryContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`

const ImageBox = styled.div`
  width: 40px;
  height: 40px;
  background-color: #e5e7eb;
  border-radius: 8px;
  overflow: hidden;

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
`

const MoreButton = styled.button`
  color: #3b82f6;
  font-size: 11px;
  cursor: pointer;
  background: none;
  border: none;
  padding: 0;
  outline: none;
  white-space: nowrap;
`

const PreviewImageContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 400px;
  background-color: #f0f0f0;
  padding: 10px 0;
  img {
    max-width: 100%;
    max-height: 100%;
    object-fit: contain;
  }
`

const ThumbnailContainer = styled.div`
  display: flex;
  justify-content: center;
  gap: 8px;
  margin-top: 10px;
`

const ThumbnailBox = styled.div`
  width: 50px;
  height: 50px;
  border: 2px solid transparent;
  cursor: pointer;
  transition: border 0.3s ease;

  &:hover {
    border-color: #3b82f6;
  }

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
`
